import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import Button from '../../../../utils/components/Button/Button'
import useModal from '../../../../utils/hooks/useModal'
import { Table } from '../../../components/Table/Table'

const ListZones = ({ zones, deleteZone }) => {
    const history = useHistory()
    const [idDeleted, setIdDeleted] = useState(null)
    const [refShow, isShow, setIsShow] = useModal(false)
    return (
        <div>
            <div className='column mb-5'>
                <Button
                    onClick={() => {
                        history.push("/Admin/CreateZone")
                    }}
                    text='Crear zona'
                />
            </div>
            <Table>
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Categoría</th>
                        <th>Descripción</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        zones.map(zone => (
                            <tr key={zone._id}>
                                <td>{zone.name}</td>
                                <td>{zone.categoryId.name}</td>
                                <td>{zone.description}</td>
                                <td>
                                    <Button
                                        onClick={() => {
                                            setIdDeleted(zone._id)
                                            setIsShow(true)
                                        }}
                                        text='Borrar'
                                    />
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </Table>
            <Modal id={idDeleted} deleteZone={deleteZone} displayModal={isShow} close={() => setIsShow(false)} />
        </div>
    )
}
const Modal = ({ id, deleteZone, displayModal, close }) => {
    const divStyle = {
        display: displayModal ? 'block' : 'none'
    }
    if (!id) {
        return <></>
    }
    return (
        <div style={divStyle} className={"modal"}>
            <div
                className="modal-content ">
                <div className='column centerContent'>
                    ¿Desea borrar la zona?
                </div>
                <div className='column centerContent'>
                    <Button
                        onClick={() => {
                            deleteZone(id,()=>close())
                        }}
                        text='Borrar' />
                    <Button
                        onClick={() => {
                            close()
                        }}
                        text='Cancelar' />
                </div>
            </div>

        </div>
    )
}
export default ListZones